module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-152x152-dd7cc63cda781f2b0f64412c507f537d.png";